






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Global } from '@/store';

@Component({})

class PowerDialog extends Vue {
    @Global.State('lang') lang;
    
    closePowerDialog() {
        this.$emit('close');
    }
}

export default PowerDialog;
